<template>
    <div
        v-if="product"
        class="w-80 bg-white shadow-sm hover:shadow-md m-4  border hover:border-black"
        :class="{
            'border shadow-md border-black':
                +product.product_id === +productStepID,
        }"
    >
        <div class="w-full flex flex-col pt-6">
            <!-- image -->
            <div
                @click="nextStep()"
                class="cursor-pointer flex justify-center bg-white h-52"
            >
                <component :is="activeMockup" :image="product.product_mockup" />
            </div>

            <div class="flex flex-col text-center">
                <span
                    class="text-xl font-medium leading-4 pt-2 pointer-events-none noselect"
                >
                    {{ product.product_name }}
                </span>
                <div v-if="!customProduct" class="flex justify-center pt-4">
                    <span class="pr-1">Wholesale price: </span>
                    <span class="text-gray-500">
                        From €
                        {{
                            product.product_starting_from
                                ? product.product_starting_from.toFixed(2)
                                : 0
                        }}
                    </span>
                </div>
                <div v-if="customProduct" class="flex justify-center pt-4">
                    <span class="pr-1">Price: </span>
                    <span class="text-gray-500">
                        €
                        {{
                            product.product_starting_from
                                ? product.product_starting_from.toFixed(2)
                                : 0
                        }}
                    </span>
                </div>
            </div>
            <div class="flex justify-center py-5">
                <button
                    v-if="!customProduct"
                    @click="nextStep()"
                    type="button"
                    class="p-1 border border-primary hover:border-transparent uppercase font-medium px-9 my-4 tracking-wider hover:text-white hover:bg-accent focus:outline-none"
                >
                    edit
                </button>
                <button
                    v-if="customProduct"
                    @click="addToCart()"
                    type="button"
                    class="p-1 border border-primary hover:border-transparent uppercase font-medium px-9 my-4 tracking-wider hover:text-white hover:bg-accent focus:outline-none"
                >
                    add to cart
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import PhotoCalendarMockup from "../../../common/components/productMockups/photoCalendarMockup.vue";
import CanvasMockup from "../../../common/components/productMockups/canvasMockup.vue";
import CardsMockup from "../../../common/components/productMockups/cardsMockup.vue";
import FramedPosterMockup from "../../../common/components/productMockups/framedPosterMockup.vue";
import HangerPosterMockup from "../../../common/components/productMockups/hangerPosterMockup.vue";
import PosterMockup from "../../../common/components/productMockups/posterMockup.vue";
import DeskVerticalCalendarMockup from "../../../common/components/productMockups/deskVerticalCalendarMockup.vue";
import DeskHorizontalCalendarMockup from "../../../common/components/productMockups/deskHorizontalCalendarMockup.vue";
import SimpleMockup from "../../../common/components/productMockups/simpleMockup.vue";

export default {
    components: {
        PhotoCalendarMockup,
        CanvasMockup,
        CardsMockup,
        FramedPosterMockup,
        HangerPosterMockup,
        PosterMockup,
        DeskVerticalCalendarMockup,
        DeskHorizontalCalendarMockup,
        SimpleMockup,
    },

    computed: {
        ...mapGetters([
            "productsToBeEnabled",
            "user",
            "currentDesign",
            "productStepID",
        ]),

        customProduct() {
            return this.customProducts.includes(this.product.product_id);
        },

        activeMockup() {
            let component = "";

            switch (this.product.product_id) {
                case 1:
                    component = "framed-poster-mockup";
                    break;
                case 2:
                    component = "poster-mockup";
                    break;
                case 3:
                    component = "canvas-mockup";
                    break;
                case 4:
                    component = "cards-mockup";
                    break;
                case 5:
                    component = "hanger-poster-mockup";
                    break;
                case 6:
                    component = "photo-calendar-mockup";
                    break;
                case 7:
                    component = "desk-horizontal-calendar-mockup";
                    break;
                case 8:
                    component = "desk-vertical-calendar-mockup";
                    break;
                case 69:
                    component = "simple-mockup";
                    break;
                default:
                    component = "simple-mockup";
                    break;
            }

            return component;
        },
    },
    methods: {
        nextStep() {
            if (!this.customProduct) {
                const id = this.product.product_id || 0;

                this.$store.dispatch("setProductStepID", id);
                this.$store.dispatch("setProductStepVariantID", null);
                this.$store.dispatch("setProductStepVariantAttribute", null);


                this.$router.push({
                    name: "variants",
                    params: { productID: id, designID: 0 },
                });
            }
        },

        goToBasket(){
            this.$router.push('/basket')
        },

        addToCart() {
            let productID = this.product.product_id

            this.$store
                .dispatch("addCustomProductToCart", productID)
                .then(() => {
                    this.$store.dispatch("getUser");
                    this.goToBasket();
                });
        },
    },

    data() {
        return {
            customProducts: [69],
        };
    },

    props: {
        product: Object,
    },
    name: "productListItem",
};
</script>

<style lang="css">
.noselect {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
</style>
